import { useState, useEffect } from 'react';
import { useForm, useTitle } from '../../hooks';

import { Box, Grid, Typography } from '@mui/material';

import colors from '../../assets/colors';
import { Button, TextField } from '../../components/common';
import { password } from '../../utils/api';

export default function ChangePassword() {
  const [isNewPasswordMatching, setIsNewPasswordMatching] = useState(true);
  const [errorText, setErrorText] = useState();
  const [success, setSuccess] = useState(false);
  const { handleChange, values } = useForm({
    password: '',
    newPassword: '',
    repeatNewPassword: '',
  });

  useTitle('AgroWe-Zmiana hasła');

  useEffect(() => {
    if (values.newPassword === values.repeatNewPassword)
      setIsNewPasswordMatching(true);
    else setIsNewPasswordMatching(false);
  }, [values.newPassword, values.repeatNewPassword]);

  const handlePasswordChange = () => {
    const body = {
      newPassword: values.newPassword,
      password: values.password,
    };
    password
      .apiChange(body)
      .then((result) => {
        setSuccess(true);
      })
      .catch((err) => {
        if (err.response.data === 'Wrong password')
          setErrorText('Podano niepoprawne aktualne hasło!');
      });
  };

  return (
    <Box
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      sx={{ mt: 10, textAlign: 'center' }}
    >
      {!success ? (
        <>
          <Typography sx={{ color: colors.agroweGreen, mb: 3 }}>
            Aby zmienić hasło podaj swoje aktualne hasło.
          </Typography>
          <Grid container direction="column" alignItems="center">
            <TextField
              modalRight
              label="Aktualne hasło"
              type="password"
              onChange={handleChange('password')}
              sx={{ maxWidth: 300 }}
            />
            <TextField
              modalRight
              label="Nowe hasło"
              type="password"
              error={!isNewPasswordMatching}
              onChange={handleChange('newPassword')}
              sx={{ maxWidth: 300 }}
            />
            <TextField
              modalRight
              label="Powtórz nowe hasło"
              type="password"
              error={!isNewPasswordMatching}
              onChange={handleChange('repeatNewPassword')}
              sx={{ maxWidth: 300, mb: 1 }}
            />
            <Typography sx={{ color: colors.redError, mb: 2 }}>
              {!isNewPasswordMatching && 'Podane hasła róznią się od siebie'}
            </Typography>
            <Typography sx={{ color: colors.redError, mb: 2 }}>
              {errorText && errorText}
            </Typography>
            <Button
              agroweGreen
              variant="outlined"
              disabled={
                !(
                  values.newPassword.length > 0 &&
                  values.repeatNewPassword.length > 0 &&
                  isNewPasswordMatching
                )
              }
              onClick={handlePasswordChange}
            >
              ZAPISZ HASŁO
            </Button>
          </Grid>
        </>
      ) : (
        <>
          <Typography
            sx={{
              color: colors.agroweGreen,
              fontSize: 36,
              fontWeight: 500,
              mt: 15,
            }}
          >
            Hasło zostało pomyślnie zmienione!
          </Typography>
        </>
      )}
    </Box>
  );
}
